export default __webpack_public_path__ + "static/media/sentByAgency.bde211aa.svg";